/* eslint-disable no-param-reassign */
import moment from "moment";

const convertBirthDateToAge = (dob) => dob && moment().diff(moment(dob, "YYYY"), "years");

const convertDateToaAge = async (contacts) => {
  const updatedContacts =
    contacts.length &&
    contacts.map((contact) => {
      contact.age = convertBirthDateToAge(contact?.birthday)?.toString();
      contact.name = `${contact?.first_name} ${contact?.last_name}`;
      return contact;
    });
  return updatedContacts;
};

const blockCustomerStart = (state) => ({ ...state, loading: true });

const blockCustomerSuccess = (state) => ({ ...state, loading: false });

const blockCustomerFail = (state, { errorMsg }) => ({ ...state, loading: false, errorMsg });

const deleteCustomerStart = (state) => ({ ...state, loading: true });

const deleteCustomerSuccess = (state) => ({ ...state, loading: false });

const deleteCustomerFail = (state, { errorMsg }) => ({ ...state, loading: false, errorMsg });

export {
  blockCustomerStart,
  blockCustomerSuccess,
  blockCustomerFail,
  deleteCustomerStart,
  deleteCustomerSuccess,
  deleteCustomerFail,
  convertDateToaAge,
};
